import { useState } from "react";
import AmountInput from "@/components/AmountInput";
import { INPUT_CLASS } from "../types/bills.types";

interface NumberFieldProps {
  value: number;
  onChange: (n: number) => void;
  disabled?: boolean;
  ariaLabel: string;
  className?: string;
}

/** Keeps the raw text so "12." and "" can be typed; commits a number upward. */
export default function NumberField({
  value,
  onChange,
  disabled,
  ariaLabel,
  className = "",
}: NumberFieldProps) {
  const [text, setText] = useState(value === 0 ? "" : String(value));
  return (
    <AmountInput
      allowNegative
      aria-label={ariaLabel}
      disabled={disabled}
      value={text}
      placeholder="0"
      onChange={(next) => {
        setText(next);
        onChange(Number(next) || 0);
      }}
      className={`${INPUT_CLASS} text-right ${className}`}
    />
  );
}
